import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["onClick", "src"]
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "empty"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "该目录下无文件夹", -1)
const _hoisted_6 = [
  _hoisted_5
]

import { PropType } from 'vue'
import Icons from '@remote/utils/static-icons'
import Checkbox from '@remote/components/Checkbox.vue'
import { replaceRootAlias } from '@remote/utils'

interface CheckableFile extends API_FILE.DriveFile {
  __isChecked?: boolean
}


export default /*#__PURE__*/_defineComponent({
  props: {
  indent: {
    type: Boolean,
    default: false,
  },
  list: {
    type: Array as PropType<CheckableFile[]>,
    default: () => ([]),
  },
  type: {
    type: String as PropType<'radio' | 'checkbox'>,
    default: 'checkbox',
  },
  aliasMap: {
    type: Object as PropType<Record<string, string>>,
    default: () => ({}),
  },
},
  emits: ['check', 'enter'],
  setup(__props, { emit }) {

const props = __props





/**
 * 如果要扩展成可以选择文件的弹窗，这里兜底要判断文件后缀展示图标
 */
const getIcon = (file?: API_FILE.DriveFile | null) => {
  if (file?.icon_link) {
    return file.icon_link
  }
  return Icons.dir
}

return (_ctx: any,_cache: any) => {
  return (__props.list.length > 0)
    ? (_openBlock(), _createElementBlock("ul", {
        key: 0,
        class: _normalizeClass({ 'indent': __props.indent })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (file) => {
          return (_openBlock(), _createElementBlock("li", {
            key: file.id
          }, [
            _createElementVNode("span", null, [
              _createVNode(Checkbox, {
                value: file.__isChecked,
                "onUpdate:value": ($event: any) => (emit('check', file)),
                type: __props.type,
                disabled: file.params?.is_write !== 'true'
              }, null, 8, ["value", "onUpdate:value", "type", "disabled"])
            ]),
            _createElementVNode("img", {
              onClick: ($event: any) => (emit('check', file)),
              src: getIcon(file)
            }, null, 8, _hoisted_1),
            _createElementVNode("p", {
              onClick: ($event: any) => (emit('check', file))
            }, _toDisplayString(_unref(replaceRootAlias)({ path: file.name ?? '', aliasMap: __props.aliasMap })), 9, _hoisted_2),
            _createElementVNode("div", {
              class: "enter",
              onClick: _withModifiers(($event: any) => (emit('enter', file)), ["stop"])
            }, null, 8, _hoisted_3)
          ]))
        }), 128))
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
}
}

})